var map = {
	"./v2-home-certificates.svg": 5393,
	"./v2-home-channels.svg": 5394,
	"./v2-home-clp.svg": 5395,
	"./v2-home-courses.svg": 5396,
	"./v2-home-exams.svg": 5397,
	"./v2-home-gamification.svg": 5398,
	"./v2-home-leaderboard.svg": 5399,
	"./v2-home-projects.svg": 5400,
	"./v2-home-resume.svg": 5401
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5392;